import isEmpty from 'lodash/isEmpty'
import { FC } from 'react'
import { MdCheckCircle, MdOpenInNew } from 'react-icons/md'
import { Link } from 'react-router-dom'

import useTracking from 'src/hooks/useTracking'
import { WizardDataStatusInterface } from 'src/types/WizardDataStatusInterface'
import { WIZARD } from 'src/utils/constant'
import WizardStatus from './WizardStatus'

import * as styles from './WizardContent.scss'

const ALL_AVAILABLE = 'all_ok'

interface WizardContentProps {
  dashboards: WizardDataStatusInterface[]
}

const WizardContent: FC<WizardContentProps> = ({ dashboards }) => {
  const isAllAvailable = !isEmpty(dashboards) && dashboards[0].type === ALL_AVAILABLE
  const newDashboards = dashboards.filter(el => el.type !== ALL_AVAILABLE)
  const { trackEvent } = useTracking()

  const onFullDataAvailabilityStatusClicked = () => {
    trackEvent({
      action: 'Check Full Data Availability',
    })
  }

  return (
    <div className={styles.DataStatus}>
      <div className={styles.DataStatusContainer}>
        <WizardStatus dashboards={newDashboards} />
        {isAllAvailable && (
          <div className={styles.EmptyStatus}>
            <MdCheckCircle className={styles.Logo} />
            <div className={styles.AllDataAvailable}>All data available</div>
          </div>
        )}
      </div>
      <div className={styles.LinkSection}>
        <Link
          to={WIZARD.full_data_url}
          className={styles.StatusLink}
          target="_blank"
          onClick={onFullDataAvailabilityStatusClicked}
          data-testid="data-status-full-data-availability-link"
        >
          {WIZARD.status_link}
          <MdOpenInNew className={styles.StatusLinkIcon} />
        </Link>
      </div>
    </div>
  )
}

export default WizardContent
